import React, { Component } from 'react'
import Slider from 'react-slick';

class AwardsSlide extends Component {
    render() {

        const settings = {
            slidesToShow: 3,
            slidesToScroll: 3,
            dots: false,
            infinite: true,
            autoplay: true,
            speed: 4000,
            autoplaySpeed: 4000,
            responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: false
                  }
                },
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
              ]           
        };


       



        return (
            <section className="brand-logo-wrapper">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <Slider className="brand-logo-carousel" {...settings}>
                                <div className="single-brand-logo vAwardsImg">
                                    <img src={require("../assets/img/whatsinaname/awards/01.png")} alt="donto" />
                                </div>
                                <div className="single-brand-logo vAwardsImg">
                                    <img src={require("../assets/img/whatsinaname/awards/02.png")} alt="donto" />
                                </div>
                                <div className="single-brand-logo vAwardsImg">
                                    <img src={require("../assets/img/whatsinaname/awards/03.png")} alt="donto" />
                                </div>
                                <div className="single-brand-logo vAwardsImg">
                                    <img src={require("../assets/img/whatsinaname/awards/04.png")} alt="donto" />
                                </div>
                                <div className="single-brand-logo vAwardsImg">
                                    <img src={require("../assets/img/whatsinaname/awards/05.png")} alt="donto" />
                                </div>
                            </Slider >
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default AwardsSlide
